/**
 * Welcome widget — greeting card with user name and quick-start tips.
 *
 * Cross-References:
 *   - FR-DASH-002: Default widgets
 *   - dashboard screen spec: Welcome widget
 */
import { useAuthStore } from '@/stores/authStore';
import type { WidgetProps } from '@/types';

export function WelcomeWidget(_props: WidgetProps) {
  const user = useAuthStore((s) => s.user);
  const displayName = user?.displayName || 'there';

  return (
    <div className="welcome-widget">
      <h4 className="welcome-widget__greeting">
        Welcome back, {displayName}!
      </h4>
      <p className="welcome-widget__subtitle">
        Here&rsquo;s what&rsquo;s happening in your organisation today.
      </p>
      <ul className="welcome-widget__tips">
        <li>Browse the <strong>Directory</strong> to find colleagues</li>
        <li>Check <strong>Quick Actions</strong> for common tasks</li>
        <li>Customise your dashboard with widgets</li>
      </ul>
    </div>
  );
}
